<template>
  <div class="home">
    <v-container>
      <v-layout>
        <v-tabs>
          <v-tab to="/entity/in-review" class="text-none">In Review</v-tab>
          <v-tab to="/entity/reviewed" class="text-none">Reviewed</v-tab>
          <!-- <v-tab to="/businesses" class="text-none">Businesses</v-tab> -->
        </v-tabs>
      </v-layout>
      <v-divider />
      <router-view />
    </v-container>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>